export enum EntityTypeNameIds
{
    Location = "Location",
    Customer = "Customer",
    Vendor = "Vendor",
    
}